import { ChartBar, Ticket } from "@phosphor-icons/react";

//Components
import DashboardPage from "views/Dashboard/Dashboard.js";
import TicketStatusDev from "views/TicketStatusDev/TicektStatusDev";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: ChartBar,
    component: DashboardPage,
    layout: "/admin",
  },
  {
    path: "/tickets",
    name: "Tickets",
    icon: Ticket,
    component: TicketStatusDev,
    layout: "/admin",
  },
];

export default dashboardRoutes;
